import {
  buildItemDisplayInfoMap,
  CustomerCartPayload,
  getBusinessLogoUrl,
  getDisplayItems,
} from "../../../../customerDisplay";

import { pushCustomerCart } from "../../../../utils/customerDisplay";
import { selectPaymentDetails } from "../../../slices/CustomerDisplay";
import { amountDecimals, amountLocale, currency } from "../../../../utils/currency";

/**
 * Mirrors cart/payment changes onto the customer-facing second screen.
 *
 * WEB-ONLY, so a single `.desktop` variant — the same shape as the four sibling effect modules.
 * Mobile has no equivalent: its display screen reads this same store directly.
 *
 * Uses listenerApi instead of store.getState() so we can compare the
 * state before and after the action.
 */
export const customerDisplayEffect = (action: any, listenerApi: any) => {
  const currentState = listenerApi.getState();

  const currentSale = currentState?.saleDataStore?.saleData;

  // the engine's legs while a payment-engine session is open, v1's stored map otherwise
  const currentPaymentDetails = selectPaymentDetails(currentState);

  // Read from the store, never from a caller-supplied flag: CheckoutContainer
  // already sets ispaymentInProcess on mount and clears it on unmount (as does
  // resetCheckoutData), so the store is the one place that knows whether the
  // payment popup is open. Taking it as an argument meant a push triggered by
  // anything else carried a stale answer — closing the popup left the display
  // stuck on "payment in progress" because no re-push ever said otherwise.
  const isPaymentInProcess =
    currentState?.customerDisplayStore?.isPaymentInProcess ?? false;


  const campaignConfig =
    currentState?.customerDisplayStore?.campaignData;

  const canCustomerEnterNumber = currentState?.customerDisplayStore?.canCustomerEnterNumber;

  // Read alongside everything else rather than pushed as its own message: the reset that follows
  // a checkout success re-pushes within the same tick, and a payload that dropped this would
  // immediately take the success screen back down.
  const saleClosedAt = currentState?.customerDisplayStore?.saleClosedAt;

  const businessData = currentState?.businessStore?.businessData;
  const staticFolder = businessData?.staticFolder;
  const staticMediaBaseUrl = staticFolder
    ? `${process.env.REACT_APP_RISTA_ITEM_BASE_URL}/${staticFolder}`
    : undefined;
  const logoUrl = getBusinessLogoUrl(businessData?.imageDataId, `${process.env.REACT_APP_RISTA_ITEM_BASE_URL}/`);

  const itemsData = currentState?.itemsStore?.itemsData;
  const tagsPriorityArr = currentState?.catalogStore?.tagsPriorityArr;
  const itemDisplayInfo = buildItemDisplayInfoMap(
    getDisplayItems(currentSale),
    itemsData,
    staticMediaBaseUrl,
    tagsPriorityArr,
  );

  const payload: CustomerCartPayload = {
    sale: currentSale,
    currency: currency(),
    decimals: amountDecimals(),
    grouping: amountLocale(),
    campaignConfig,
    staticMediaBaseUrl,
    logoUrl,
    itemDisplayInfo,
    paymentDetails: currentPaymentDetails,
    isPaymentInProcess,
    canCustomerEnterNumber,
    saleClosedAt,
  };

  pushCustomerCart(payload);
};
